import { render, staticRenderFns } from "./addInvoice.vue?vue&type=template&id=4fe41326&scoped=true&lang=html&"
import script from "./addInvoice.vue?vue&type=script&lang=js&"
export * from "./addInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe41326",
  null
  
)

export default component.exports